import * as React from 'react';
import { useSelector } from 'react-redux';
import { BuilderChatPhone } from '../../components/BuilderChatPhone';
import { getNewbuildingId } from '../../selectors/newbuilding';
import { INewbuildingSeller } from '../../types/newbuilding/seller';
import { INewbuildingBuilder } from '../../types/newbuilding/builder';
import { BuilderChatDynamicPhone } from '../BuilderChatDynamicPhone';
import { trackShowPhone } from './tracking';
import { getGALabel } from '../../selectors/newbuilding/getGALabel';
import { phoneToString } from '../../utils/businessLogic/phone/phoneToString';
import { formatPhone } from '../../components/CallSeller/utils/formatPhone';

interface ICallButtonProps {
  onClick: () => void;
}

interface IBuilderChatCallContainerProps {
  sellers: INewbuildingSeller[];
  builders: INewbuildingBuilder[];
  CallButtonComponent: React.ComponentType<ICallButtonProps>;
}

export const BuilderChatCallContainer = ({
  sellers,
  builders,
  CallButtonComponent,
}: IBuilderChatCallContainerProps) => {
  const [isPhoneShown, setIsPhoneShown] = React.useState(false);

  const gaLabel = useSelector(getGALabel);
  const newbuildingId = useSelector(getNewbuildingId);

  const contact: INewbuildingBuilder | INewbuildingSeller = React.useMemo(() => {
    // Из библиотеки чата ожидается только один контакт
    return [...sellers, ...builders][0];
  }, [sellers, builders]);

  const notFormattedPhone = React.useMemo(() => phoneToString(contact.phone), [contact]);
  const formattedPhone = React.useMemo(() => formatPhone(notFormattedPhone), [notFormattedPhone]) as string;

  const onClick = React.useCallback(() => {
    trackShowPhone({
      gaLabel,
      newbuildingId,
      isBuilder: builders.length > 0,
    });
    setIsPhoneShown(true);
  }, [builders.length, gaLabel, newbuildingId]);

  if (isPhoneShown && contact.dynamicCalltracking?.siteBlockId) {
    return (
      <BuilderChatDynamicPhone
        siteBlockId={contact.dynamicCalltracking.siteBlockId}
        notFormattedPhone={notFormattedPhone}
        phoneNumber={formattedPhone}
      />
    );
  }

  if (isPhoneShown) {
    return <BuilderChatPhone phone={formattedPhone} />;
  }

  return <CallButtonComponent onClick={onClick} />;
};
